function initTestimonialCards() {
  document.querySelectorAll('.testimonials-carousel__card').forEach((card) => {
    const text = card.querySelector('.testimonials-carousel__text');
    const inner = card.querySelector('.testimonials-carousel__text-inner');
    const button = card.querySelector('.testimonials-carousel__read-more');
    if (!text || !inner || !button) return;

    const clampedHeight = inner.clientHeight;
    text.classList.add('is-expanded');
    const fullHeight = inner.scrollHeight;
    text.classList.remove('is-expanded');

    button.hidden = fullHeight <= clampedHeight + 2;

    if (!button.dataset.listenerAttached) {
      button.dataset.listenerAttached = 'true';
      button.addEventListener('click', () => {
        const expanded = text.classList.toggle('is-expanded');
        button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      });
    }
  });
}

function updateTestimonialsNavVisibility() {
  document.querySelectorAll('.testimonials-carousel__slider').forEach((slider) => {
    const list = slider.querySelector('.testimonials-carousel__list');
    const nav = slider.querySelector('.testimonials-carousel__nav');
    if (!list || !nav) return;
    nav.hidden = list.scrollWidth <= list.clientWidth + 1;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initTestimonialCards();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initTestimonialCards);
  }

  updateTestimonialsNavVisibility();
  document.querySelectorAll('.testimonials-carousel__list').forEach((list) => {
    new ResizeObserver(updateTestimonialsNavVisibility).observe(list);
  });
});

document.addEventListener('shopify:section:load', () => {
  initTestimonialCards();
  updateTestimonialsNavVisibility();
});
